// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import AccountBookOutlinedSvg from "@fishx/icons-svg/es/asn/AccountBookOutlined";
import FishxIcon from '../components/FishxIcon';

var AccountBookOutlined = function AccountBookOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: AccountBookOutlinedSvg
  }));
};

AccountBookOutlined.displayName = 'AccountBookOutlined';
export default React.forwardRef(AccountBookOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/AccountBookOutlined.js
// module id = 1937
// module chunks = 0